"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Logo = void 0;
const classnames_1 = __importDefault(require("classnames"));
const react_1 = __importDefault(require("react"));
const ThemeProvider_1 = require("../../themes/ThemeProvider");
const Logo_module_css_1 = __importDefault(require("./Logo.module.css"));
const Logo = ({ variant = 'primary', size = 'sm', ...props }) => {
    const id = ThemeProvider_1.useTheme();
    const theme = process.env.REACT_APP_THEME
        ? require(`./themes/${process.env.REACT_APP_THEME}/theme.module.css`)
        : require(`./themes/${id}/theme.module.css`);
    return (react_1.default.createElement("span", Object.assign({}, props, { "data-e2e": "logotype", className: classnames_1.default(props.className, Logo_module_css_1.default.logo, theme[`size-${size}`], theme['logo-logo'], theme[`variation-${variant}`]) })));
};
exports.Logo = Logo;
//# sourceMappingURL=Logo.js.map